import { render, staticRenderFns } from "./DataHistoryChart.vue?vue&type=template&id=2e4f13fb&scoped=true&"
import script from "./DataHistoryChart.vue?vue&type=script&lang=ts&"
export * from "./DataHistoryChart.vue?vue&type=script&lang=ts&"
import style0 from "./DataHistoryChart.vue?vue&type=style&index=0&id=2e4f13fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f13fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VProgressCircular,VTooltip})
